(function () {
  'use strict';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isCoarse() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function init(root) {
    if (!root || root.dataset.sciReady === '1') return;
    root.dataset.sciReady = '1';

    var stage = root.querySelector('[data-sci-stage]');

    if (reducedMotion()) {
      root.classList.add('is-float');
    } else {
      var shown = false;

      function reveal() {
        if (shown) return;
        shown = true;
        root.classList.add('is-enter');
        window.setTimeout(function () {
          root.classList.remove('is-enter');
          root.classList.add('is-float');
        }, 1200);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            reveal();
            observer.disconnect();
          });
        }, { threshold: 0.28 });
        observer.observe(root);
      } else {
        reveal();
      }
    }

    if (!stage || reducedMotion() || isCoarse()) return;

    var mx = 0;
    var my = 0;
    var tx = 0;
    var ty = 0;
    var raf = 0;

    function apply() {
      raf = 0;
      mx += (tx - mx) * 0.1;
      my += (ty - my) * 0.1;
      root.style.setProperty('--sci-mx', mx.toFixed(4));
      root.style.setProperty('--sci-my', my.toFixed(4));
      if (Math.abs(tx - mx) > 0.001 || Math.abs(ty - my) > 0.001) {
        raf = requestAnimationFrame(apply);
      }
    }

    stage.addEventListener('pointermove', function (event) {
      var rect = stage.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      tx = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      ty = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(apply);
    });

    stage.addEventListener('pointerleave', function () {
      tx = 0;
      ty = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-science-formula]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-science-formula]')
      : null;
    if (section) {
      section.dataset.sciReady = '';
      init(section);
    } else if (event.target && event.target.matches && event.target.matches('[data-science-formula]')) {
      event.target.dataset.sciReady = '';
      init(event.target);
    }
  });
})();
